(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("marketing_script_bundle", [], factory);
	else if(typeof exports === 'object')
		exports["marketing_script_bundle"] = factory();
	else
		root["marketing_script_bundle"] = factory();
})(this, function() {
return 